import classnames from 'classnames';
import React from 'react';
import { Modal, ModalProps } from '../modal/modal';

export type SideDrawerProps = ModalProps;

export const SideDrawer = (props: SideDrawerProps): React.ReactElement => {
  const { rootElementId = 'airtame-sidedrawer-root', children, className, ...modalProps } = props;

  const sideDrawerClassName = classnames('airtame-side-drawer', className);

  return (
    <Modal
      rootElementId={rootElementId}
      className={sideDrawerClassName}
      hideCloseIcon
      {...modalProps}
    >
      {children}
    </Modal>
  );
};

SideDrawer.displayName = 'SideDrawer';
